import React from 'react'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import { useRouter } from 'next/router'

import { AppButtons } from 'components/Molecules/DownloadApp'
import { useClientResponsive } from 'helpers/hooks'

import PhoneNumberForm from '../PhoneNumberForm'

import Copy from './Copy'
import Image from './Image'

const Background = styled.div`
  padding: 30px 0;
  background-color: ${props => props.theme.palette.primary};

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    padding: 80px 0;
  }
`

const Hero = () => {
  const router = useRouter()
  const { isMobile } = useClientResponsive()

  return (
    <Background>
      <Grid>
        <Row middle="sm">
          <Col xs={12} sm={false}>
            <Image />
          </Col>
          <Col xs={12} sm={6}>
            <Copy />
            <PhoneNumberForm token={router?.query?.token} />
            {isMobile && <AppButtons />}
          </Col>
          <Col xs={false} sm={5} smOffset={1}>
            <Image />
          </Col>
        </Row>
      </Grid>
    </Background>
  )
}

export default Hero
